import { render } from "./privacy_policy.vue?vue&type=template&id=b1809ef6&scoped=true"
import script from "./privacy_policy.vue?vue&type=script&lang=js"
export * from "./privacy_policy.vue?vue&type=script&lang=js"

import "./privacy_policy.vue?vue&type=style&index=0&id=b1809ef6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1809ef6"]])

export default __exports__